import React from "react";
import { getData } from "../../utils/data";
import { EData } from "../../interfaces/enum";
import { Item, TrendingRowData } from "../../interfaces/interfaces";
import classNames from "classnames";
import styles from "./TrendingRow.module.scss";
import SkeletonRow from "../Rows/SkeletonRow/SkeletonRow";
import Row from "../Rows/Row/Row";
import { Skeleton } from "@mui/material";

export type TrendingRowProps = {
  items: Item[];
};

const TrendingRow = ({ items }: TrendingRowProps) => {
  const data = getData(EData.TRENDING_ROW) as TrendingRowData;
  return (
    <div>
      <div className={classNames(styles.title)}>
        {items.length === 0 ? (
          <Skeleton
            variant="text"
            className={classNames(styles.skeleton)}
            width={150}
          />
        ) : (
          data.title
        )}
      </div>
      <div className="mb-4">
        {items.length === 0 ? <SkeletonRow /> : <Row items={items} />}
      </div>
    </div>
  );
};

export default TrendingRow;
